import { render } from "./ExportFinanc.vue?vue&type=template&id=d9fc8ff0&scoped=true"
const script = {}

import "./ExportFinanc.vue?vue&type=style&index=0&id=d9fc8ff0&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fc8ff0"]])

export default __exports__